import React, { useState } from "react";
import { Box, IconButton, Drawer, useMediaQuery } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import JobFilterSidebar from "./JobFilterMUI";

export default function JobFilterResponsive({ onChange, categories }) {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* MOBILE FILTER ICON */}
      {isMobile && (
        <Box
          p={1}
          sx={{
            width: "auto",
            height: "auto",
            display: "flex",
            justifyContent: { xs: "flex-end" },
          }}
        >
          <IconButton
            color="primary"
            onClick={(e) => {
              setOpen(true);
              e.stopPropagation();
              console.log(e.target.type);
            }}
            type="button"
            sx={{
              bgcolor: "primary.main",
              color: "#fff",
              boxShadow: 3,
              "&:hover": { bgcolor: "primary.dark" },
              width: "48px",
              height: "48px",
            }}
          >
            <FilterListIcon />
          </IconButton>
        </Box>
      )}

      {/* DESKTOP SIDEBAR */}
      {!isMobile && (
        <JobFilterSidebar onChange={onChange} categories={categories} />
      )}

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="left"
        open={open}
        PaperProps={{
          sx: {
            maxHeight: "100vh",
          },
        }}
        onClose={() => {
          const scrollY = window.scrollY;
          setOpen(false);
          // Restore scroll position
          setTimeout(() => window.scrollTo(0, scrollY), 10);
        }}
        ModalProps={{
          disableScrollLock: true,
          disableAutoFocus: true,
          disableEnforceFocus: true,
          keepMounted: false,
          onRendered: () => {
            // Prevent any auto-scroll
            const scrollY = window.scrollY;
            window.scrollTo(0, scrollY);
          },
        }}
      >
        <Box sx={{ p: 2, height: "100%" }}>
          <JobFilterSidebar
            onChange={(filters) => {
              onChange(filters);
              setOpen(false); // auto-close after change
            }}
            categories={categories}
          />
        </Box>
      </Drawer>
    </>
  );
}
